import { render, staticRenderFns } from "./CreatePassengerGroup.vue?vue&type=template&id=5c8e8ec0"
import script from "./CreatePassengerGroup.vue?vue&type=script&lang=ts"
export * from "./CreatePassengerGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports